import React, { useState, useEffect } from 'react';
import presetApi from '@services/presetApi.jsx';

const PresetQrPageSetting = ({ preset }) => {
    const [isLoading, setIsLoading] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const presetId = searchParams.get('presetId');
    const [presetQrViewerPage, setPresetQrViewerPage] = useState(null);

    // 폼 데이터 상태
    const [formData, setFormData] = useState({
        languageCode: 'korean',
        additionalOptions: null,
        isActive: true
    });

    // 페이지 데이터 로드
    useEffect(() => {
        loadQrViewerPageData();
    }, [presetId]);

    // QR 뷰어 페이지 데이터 로드
    const loadQrViewerPageData = async () => {
        try {
            setIsLoading(true);
            const qrViewerPage = await presetApi.getQrViewerPage(presetId);
            
            setPresetQrViewerPage(qrViewerPage);
            
            setFormData({
                languageCode: qrViewerPage.languageCode ?? 'korean',
                additionalOptions: qrViewerPage.additionalOptions ?? null,
                isActive: qrViewerPage.isActive ?? true
            });
        } catch (error) {
            console.error('QR 뷰어 페이지 데이터 로드 실패:', error);
            // 에러 시 기본값 유지
        } finally {
            setIsLoading(false);
        }
    };

    // 언어 변경 핸들러
    const handleLanguageChange = (e) => {
        const newLanguage = e.target.value;
        setFormData({
            ...formData,
            languageCode: newLanguage
        });
    };

    // 저장 이벤트 리스너
    useEffect(() => {
        const eventName = `savePagePreset_qr_page`;

        const saveHandler = async (event) => {
            if (!preset?.id) {
                alert("프리셋 정보가 없습니다.");
                return;
            }

            try {
                setIsLoading(true);

                const dataToSave = {
                    presetId: event.detail.presetId,
                    languageCode: formData.languageCode,
                    additionalOptions: formData.additionalOptions,
                    isActive: formData.isActive
                };
                
                const response = await presetApi.saveQrViewerPage(event.detail.presetId, dataToSave);
                console.log("QR 뷰어 페이지 저장 성공:", response);

                // 저장 후 최신 데이터로 화면 갱신
                if (response) {
                    setFormData(response);
                    setPresetQrViewerPage(response);
                }

            } catch (error) {
                console.error("QR 뷰어 페이지 저장 실패:", error);
                alert("QR 뷰어 페이지 저장 중 오류가 발생했습니다.");
            } finally {
                setIsLoading(false);
            }
        };

        document.addEventListener(eventName, saveHandler);

        return () => {
            document.removeEventListener(eventName, saveHandler);
        };
    }, [preset?.id, formData]);

    if (isLoading) {
        return <div className="preset-settings">로딩 중...</div>;
    }

    return (
        <div className="preset-settings">
            {/* 언어 선택 섹션 */}
            <div className="settings-box">
                <h4 className="settings-title">언어 선택</h4>
                <div className="option-select-container">
                    <select 
                        className="option-select"
                        value={formData.languageCode}
                        onChange={handleLanguageChange}
                    >
                        <option value="korean">한국어</option>
                        <option value="english">영어</option>
                        <option value="japanese">일본어</option>
                        <option value="chinese">중국어</option>
                    </select>
                    <i className="ri-arrow-down-s-line select-arrow"></i>
                </div>
            </div>   
        </div>
    );
};

export default PresetQrPageSetting;
